import React from 'react'
import { handleLink } from '../../modules/utils';
import FooterPage from '../footer';
import TopNavPage2 from '../topNav2';


const TutSitePage: React.FunctionComponent = props => {
    return (
        <>
        <TopNavPage2 />
        <div className="section pt-3">
            <div className="container px-3 px-md-4">
            <div className="d-flex align-items-center justify-content-between flex-column flex-md-row">
                <h5 className="title mb-3 me-3">數位讀寫資源</h5>
                <h5 className="order-2 order-md-1 mb-3">好站推薦</h5>
                <div className="order-1 order-md-2 mb-3 text-center text-md-end" style={{width:'232px'}}>
                <button type="button" className="btn btn-outline-dark mb-0" onClick={()=>handleLink('/tutorial')}>
                    <i className="fas fa-chevron-left"></i>
                    返回 數位讀寫資源
                </button>
                </div>
            </div>

            <div className="d-flex flex-wrap my-5">
                <a href="https://timssandpirls.bc.edu/index.html" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_EngPirls.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">Pirls 國際官網</div>
                </a>
                <a href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1201" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_pirls.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">PIRLS 2021臺灣計畫官網</div>
                </a>
                <a href="https://www.oecd.org/pisa/" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_pisa.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">Pisa 國際官網</div>
                </a>
                <a href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1224" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_pisa.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">PISA 臺灣計畫官網</div>
                </a>
                <a href="https://kids.frontiersin.org/" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_youngminds.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">Frontiers for Young Minds</div>
                </a>
                <a href="https://www.hwaweiko.tw/" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web-3Study.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">柯華葳教授閱讀研究中心</div>
                </a>
                <a href="https://flipedu.parenting.com.tw/article/5071" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_flipedu.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">翻轉教育</div>
                </a>
                <a href="https://cirn.moe.edu.tw/Module/index.aspx?sid=1198" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_KnowClass.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">課文本位閱讀理解教學</div>
                </a>
                <a href="https://kids.twreporter.org/" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/KidsTwreporter.svg" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">少年報導者</div>
                </a>
                <a href="https://nie.mdnkids.com/teaching9.html?fbclid=IwAR0PVfkXzN9pgR2pYb7kU3Go_IPB03TUCct0vBON0A45c2z1nMtBIo0yoFI" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_nie.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">國語日報多文本讀報學習單</div>
                </a>
                <a href="https://futurecity.cw.com.tw/article/1867" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web-SDGs.jpg" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">永續發展目標SDGs<br/>(未來城市@天下)</div>
                </a>
                <a href="https://reading.tp.edu.tw/" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_taipei.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">臺北市深耕閱讀教育網</div>
                </a>
                <a href="http://www.family977.com.tw/index.php?route=choice/program_detail&choice_program_id=85&page=1" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_readpush.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">閱讀推手(古典音樂台)</div>
                </a>
                <div className="col-6 col-md-4 col-lg-3 tsite">
                <div className="mb-3">
                <a href="https://ers.nlpi.edu.tw/" target="_blank" rel="noopener noreferrer">
                <img src="./assets/img/tut/web_nlpi.png" alt="" className="mw-100 mb-3"/>
                </a>
                </div>
                <div className="fw-bolder h5 mb-2">國立公共資訊圖書館</div>
                <div className="mb-2">
                <a href="https://www.youtube.com/watch?v=a3RttcPA48w" target="_blank" rel="noopener noreferrer" className="text-decoration-none">數位資源服務介紹(影音)</a>
                </div>
                <div>
                <a href="https://drive.google.com/file/d/1xQk27rsGqcFhL9WCNy3SSWNvcSsp-k4J/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="text-decoration-none">數位資源服務介紹(簡報)</a>
                </div>
                </div>
                <a href="https://ebook.nlpi.edu.tw/index" target="_blank" rel="noopener noreferrer" className="col-6 col-md-4 col-lg-3 tsite">
                <img src="./assets/img/tut/web_nlpi_2.png" alt="" className="mw-100 mb-3"/>
                <div className="fw-bolder h5 mb-0">國立公共資訊圖書館<br/>電子書服務平台</div>
                </a>
            </div>

            <div className="pt-3 mt-4"></div>
            </div>
        </div>
            

        <FooterPage/>
        </>
    );
}

export default TutSitePage;